import { defineProperty as _defineProperty, objectSpread2 as _objectSpread2, inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import 'react-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { TextInput } from 'carbon-components-react';
import { FW_PREFIX } from '../../shared/constants/generalConstants.js';

var _excluded = ["showCharacterCount"];
var IlTextInput = /*#__PURE__*/function (_Component) {
  function IlTextInput(props) {
    var _this;
    _classCallCheck(this, IlTextInput);
    _this = _callSuper(this, IlTextInput, [props]);
    _defineProperty(_this, "renderTextInputLabel", function () {
      var _value$toString;
      var _this$props = _this.props,
        value = _this$props.value,
        labelText = _this$props.labelText,
        hideLabel = _this$props.hideLabel,
        showCharacterCount = _this$props.showCharacterCount,
        maxLength = _this$props.maxLength;
      var characterCountText = (value === null || value === void 0 || (_value$toString = value.toString()) === null || _value$toString === void 0 ? void 0 : _value$toString.length) || 0;
      var shouldShowCharacterCount = showCharacterCount && maxLength;
      if ((hideLabel || !labelText) && !shouldShowCharacterCount) {
        return undefined;
      }
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !hideLabel && labelText, shouldShowCharacterCount && /*#__PURE__*/React__default.createElement("span", {
        className: classNames("".concat(FW_PREFIX, "__CharacterCount"), {
          characterCountError: maxLength === characterCountText
        })
      }, characterCountText, "/", maxLength));
    });
    _this.rootRef = /*#__PURE__*/React__default.createRef();
    return _this;
  }
  _inherits(IlTextInput, _Component);
  return _createClass(IlTextInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props;
        _this$props2.showCharacterCount;
        var otherProps = _objectWithoutProperties(_this$props2, _excluded);
      var renderLabelText = this.renderTextInputLabel();
      return /*#__PURE__*/React__default.createElement("div", {
        ref: this.rootRef,
        "data-type": this.props.type,
        className: classNames("".concat(FW_PREFIX, "__IlTextInput"), "".concat(FW_PREFIX, "__IlTextInput-").concat(this.props.size), {
          hideHelperText: this.props.invalid
        })
      }, /*#__PURE__*/React__default.createElement(TextInput, _extends({}, otherProps, {
        labelText: renderLabelText,
        hideLabel: !renderLabelText,
        "aria-labelledby": this.props.id
      })));
    }
  }]);
}(Component);
_defineProperty(IlTextInput, "propTypes", _objectSpread2(_objectSpread2({}, TextInput.propTypes), {}, {
  size: PropTypes.oneOf(['sm', 'xl']),
  showCharacterCount: PropTypes.bool,
  maxLength: PropTypes.number
}));
_defineProperty(IlTextInput, "defaultProps", {
  size: 'xl'
});

export { IlTextInput };
